import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";

const DateInput = ({ value, onChange, onBlur, isInvalid, isValid, error }) => {
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  // Populate the dropdowns when Formik supplies an existing DOB.
  useEffect(() => {
    if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [y, m, d] = value.split("-");

      setYear(y);
      setMonth(m);
      setDay(d);
    } else if (!value) {
      setDay("");
      setMonth("");
      setYear("");
    }
  }, [value]);

  const updateDate = (newDay, newMonth, newYear) => {
    if (!newDay || !newMonth || !newYear) return;

    const yyyy = newYear;
    const mm = String(newMonth).padStart(2, "0");
    const dd = String(newDay).padStart(2, "0");

    onChange(`${yyyy}-${mm}-${dd}`);
  };

  const inputStyle = {
    textAlign: "center",
    fontSize: "14px",
    padding: "6px 4px",
    height: "38px",
    minHeight: "38px",
  };

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  return (
    <Form.Group>
      <Form.Label>Date of Birth *</Form.Label>

      <Row noGutters>
        <Col xs={2} className="pr-1">
          <Form.Control
            as="select"
            value={day}
            style={inputStyle}
            isInvalid={isInvalid}
            aria-label="Day"
            onChange={(e) => {
              const selectedDay = e.target.value;
              setDay(selectedDay);
              updateDate(selectedDay, month, year);
            }}
            onBlur={onBlur}
          >
            <option value="">Day</option>
            {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
              <option key={d} value={String(d).padStart(2, "0")}>
                {d}
              </option>
            ))}
          </Form.Control>
        </Col>

        <Col xs={3} className="px-1">
          <Form.Control
            as="select"
            value={month}
            style={inputStyle}
            isInvalid={isInvalid}
            aria-label="Month"
            onChange={(e) => {
              const selectedMonth = e.target.value;
              setMonth(selectedMonth);
              updateDate(day, selectedMonth, year);
            }}
            onBlur={onBlur}
          >
            <option value="">Month</option>
            {months.map((name, i) => (
              <option key={i + 1} value={String(i + 1).padStart(2, "0")}>
                {name}
              </option>
            ))}
          </Form.Control>
        </Col>

        <Col xs={3} className="pl-1">
          <Form.Control
            as="select"
            value={year}
            style={inputStyle}
            isInvalid={isInvalid}
            aria-label="Year"
            onChange={(e) => {
              const selectedYear = e.target.value;
              setYear(selectedYear);
              updateDate(day, month, selectedYear);
            }}
            onBlur={onBlur}
          >
            <option value="">Year</option>
            {Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => new Date().getFullYear() - i).map((y) => (
              <option key={y} value={String(y)}>
                {y}
              </option>
            ))}
          </Form.Control>
        </Col>
      </Row>

      {isInvalid && error && <div className="invalid-feedback d-block">{error}</div>}
    </Form.Group>
  );
};

export default DateInput;
